﻿const budgetFromDropdown = document.querySelector('#from-dropdown');
const budgetToDropdown = document.querySelector('#to-dropdown');

const manufacturerDropdown = document.querySelector('#nav-manufacturer-dropdown');
const modelDropdown = document.querySelector('#nav-model-dropdown');
const modelsFullList = Array.from(modelDropdown.children);

const budgetViewResultsButton = document.querySelector('#view-budget-results-cta');
const modelViewResultsButton = document.querySelector('#view-cars-results-cta');

export const zenNavDropdown = () => {
    const disabledClass = 'disabled';
    const dataLinkFormatBudget = budgetViewResultsButton.getAttribute('data-link-format');
    const dataLinkFormat = modelViewResultsButton.getAttribute('data-link-format');

    const enableSecondSelect = () => {
        var secondDropdown = document.querySelectorAll('.nav-submenu__list--open .dropdown')[1];
        var resultsButton = document.querySelector('.nav-submenu__list--open .nav-selector__cta a');
        secondDropdown.removeAttribute(disabledClass);
        resultsButton.classList.remove(disabledClass);
        resultsButton.removeAttribute('tabindex');
        resultsButton.setAttribute('aria-disabled', false);
        disableLowerBudget();
        getBudgetSearchUrl();
        getModelSearchUrl();
        generateModelList();
    };

    const getBudgetSearchUrl = () => {
        var url;

        const priceFrom = budgetFromDropdown.value.replace('£', '');
        const priceTo = isNaN(budgetToDropdown.value.replace('£', '')) ? '' : budgetToDropdown.value.replace('£', '');

        if (budgetFromDropdown.value === '') {
            url = encodeURI((dataLinkFormatBudget.replace('{from}', '').replace('{to}', '').replace(/^(.+?)\/*?$/, '$1')));
        }
        else if (budgetToDropdown.value === '') {
            url = encodeURI((dataLinkFormatBudget.replace('{from}', priceFrom).replace('{to}', '0')));
        }
        url = encodeURI((dataLinkFormatBudget.replace('{from}', priceFrom).replace('{to}', priceTo)));

        budgetViewResultsButton.href = url;
    };

    const getModelSearchUrl = () => {
        var url;
        if (manufacturerDropdown.value === '') {
            url = encodeURI((dataLinkFormat.replace('{from}', '').replace('{to}', '').replace(/^(.+?)\/*?$/, '$1')));
        }
        else if (modelDropdown.value === '') {
            url = encodeURI((dataLinkFormat.replace('{from}', manufacturerDropdown.value).replace('{to}', '0')).replaceAll('£', ''));
        }
        url = encodeURI(dataLinkFormat.replace('{make}', manufacturerDropdown.value.toLowerCase().replace(' ', '-')).replace('{range}', modelDropdown.value.toLowerCase().replace(' ', '-')).replace(/^(.+?)\/*?$/, '$1'));

        modelViewResultsButton.href = url;
    };

    const disableLowerBudget = () => {
        var optionsSecondDropdownOpen = budgetToDropdown.querySelectorAll('.dropdown__option');
        optionsSecondDropdownOpen.forEach((option) => {
            option.removeAttribute('disabled');
            if (Number(option.value.replace('£', '')) <= Number(budgetFromDropdown.value.replace('£', ''))) {
                option.setAttribute('disabled', true);
            }
        })
    };

    const resetMaxInput = () => {
        if (Number(budgetToDropdown.value.replace('£', '')) <= Number(budgetFromDropdown.value.replace('£', ''))) {
            budgetToDropdown.value = '';
            getBudgetSearchUrl();
        }
    };

    const resetModel = () => {
        modelDropdown.value = '';
        getModelSearchUrl();
    };

    const generateModelList = () => {
        const manufacturerDropdown = document.querySelector('#nav-manufacturer-dropdown');

        const filteredModels = modelsFullList.filter(option =>
            option.getAttribute('data-make') === manufacturerDropdown.value
        );

        const firstOption = modelDropdown[0];
        modelDropdown.innerHTML = null;
        modelDropdown.add(firstOption);

        filteredModels.forEach(model => modelDropdown.appendChild(model));
    }

    const init = () => {
        budgetToDropdown.setAttribute(disabledClass, 'true');
        budgetToDropdown.setAttribute('aria-disabled', 'true');

        modelDropdown.setAttribute(disabledClass, 'true');
        modelDropdown.setAttribute('aria-disabled', 'true');

        budgetViewResultsButton.classList.add(disabledClass);
        budgetViewResultsButton.setAttribute('aria-disabled', 'true');
        budgetViewResultsButton.setAttribute('tabindex', '-1');

        modelViewResultsButton.classList.add(disabledClass);
        modelViewResultsButton.setAttribute('aria-disabled', 'true');
        modelViewResultsButton.setAttribute('tabindex', '-1');

        manufacturerDropdown.addEventListener('change', enableSecondSelect);
        budgetFromDropdown.addEventListener('change', enableSecondSelect);
        budgetToDropdown.addEventListener('change', getBudgetSearchUrl);
        budgetFromDropdown.addEventListener('change', resetMaxInput);
        modelDropdown.addEventListener('change', getModelSearchUrl);
        manufacturerDropdown.addEventListener('change', resetModel);
    };

    return {
        init: init
    };
};